// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion[data-v-1d2bb342]{width:100%}.accordion__heading[data-v-1d2bb342]{display:flex;justify-content:space-between;align-items:center;min-width:100%;color:#fff;list-style:none}.accordion__heading[data-v-1d2bb342]:hover{cursor:pointer}.accordion__heading__title[data-v-1d2bb342]{-webkit-font-smoothing:antialiased;font-family:Anton,Anton-Fallback,Impact;font-size:22px;font-weight:400;line-height:32px;letter-spacing:.02em;text-transform:uppercase;margin-block:0}", ""]);
// Exports
module.exports = exports;
